import { AccountType } from '@mews-commander/data-access';
import { TextKey } from '@mews-commander/enums';
import { CompanyBillingEnterpriseLink, CustomerBillingEnterpriseLink } from '../../../../common/BillingEnterpriseLinks';
import { PaymentDetailsSidebarRow } from '../PaymentDetailsSidebarRow';
import { usePaymentDetailsSidebarContext } from '../../context/PaymentDetailsSidebarContext';

export const BillDetails = () => {
    const { accountId, paymentDetails } = usePaymentDetailsSidebarContext();

    if (
        !paymentDetails?.billDetails?.billId ||
        !paymentDetails?.billDetails?.billName ||
        !paymentDetails?.originalPayerAccountType
    ) {
        return null;
    }

    const { billId, billName } = paymentDetails.billDetails;
    const { originalPayerAccountType } = paymentDetails;

    const AccountBillingLink =
        originalPayerAccountType === AccountType.Company ? CompanyBillingEnterpriseLink : CustomerBillingEnterpriseLink;
    return (
        <PaymentDetailsSidebarRow labelTextKey={TextKey.Bill}>
            <AccountBillingLink accountId={accountId} billId={billId}>
                {billName}
            </AccountBillingLink>
        </PaymentDetailsSidebarRow>
    );
};
